import { RequestDataProvider, RequestSender, useRequestSender } from 'request-sender';
import { useTokenContext } from '../Authentication';
import { useApiConfiguration } from './ApiConfigurationContext';
import { useTimezoneService } from './timezoneService';

export function useStreamingGatewayApi(): RequestSender {
  const tokenContext = useTokenContext();
  const apiConfiguration = useApiConfiguration();
  const timezoneService = useTimezoneService();

  if (!apiConfiguration.streamingGatewayUrl) {
    throw new Error('streamingGatewayUrl is not configured in ApiConfigurationContext');
  }

  const token = tokenContext.getApiHeaders()['X-NEKST-TOKEN'] || '';

  const dataProviders: RequestDataProvider[] = [
    {
      getHeaders: () => ({
        'Authorization': `Bearer ${token}`,
      }),
    },
    {
      getHeaders: () => ({
        'X-NEKST-TIMEZONE': timezoneService.getTimezone(),
      }),
    },
  ];

  return useRequestSender({
    baseUrl: apiConfiguration.streamingGatewayUrl,
    dataProviders,
  });
}

export function useStreamingGatewayUrl(): string {
  const apiConfiguration = useApiConfiguration();

  if (!apiConfiguration.streamingGatewayUrl) {
    throw new Error('streamingGatewayUrl is not configured in ApiConfigurationContext');
  }

  return apiConfiguration.streamingGatewayUrl;
}

export function useStreamingGatewayAuthToken(): string {
  const tokenContext = useTokenContext();
  const headers = tokenContext.getApiHeaders();

  return headers['X-NEKST-TOKEN'] || '';
}
